import Upload from './Upload';
import useFileUpload from './fileUploadHooks';
export { default as UploadWithHooks } from './UploadWithHooks';
var CustomUpload = Upload;
CustomUpload.useFileUpload = useFileUpload;
export default CustomUpload;